export const intervalTypesMap = {
  classic: 0,
  byInterval: 1,
};

export const intervalTypeIds = Object.values(intervalTypesMap);

export const defaultIntervalTypeId = intervalTypesMap.classic;
